module.exports = __webpack_public_path__ + "media/images/v3/Satisfaction-2da28fc550538ec4525c01724ad2c7cf.png";